import createSagaMiddleware from 'redux-saga'
import { createStore, applyMiddleware, compose } from 'redux'
import { rootReducer } from './reducers'
import { rootSaga } from './sagas'
export let store
export let persistor

export const getCreateStore = () => {
  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose
  const sagaMiddleware = createSagaMiddleware()
  store = createStore(
    rootReducer(),
    composeEnhancers(applyMiddleware(sagaMiddleware))
  )
  sagaMiddleware.run(rootSaga)

  return { store }
}

export const getState = () => {
  return store.getState()
}
